var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<span ng-if=\"$ctrl.address.name || $ctrl.address.companyName || $ctrl.address.address\">{{::$ctrl.address.companyName }}, {{::$ctrl.address.address + ($ctrl.address.address2 ? ', ' + $ctrl.address.address2 : '') }}, {{::$ctrl.address.city}}, {{::$ctrl.address.state}} {{::$ctrl.address.zip}}</span>";
var id1="address-info.inline.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;